/* ThreadMuse — custom front-end fixes (added after the BEAE page-builder app was
   uninstalled; the app's JS no longer binds the tab/accordion interactions).
   Keep this file small and self-contained. */
(function () {
  'use strict';

  /* Make the BEAE "tabs rendered as accordion" blocks toggle again.
     Structure: .beae-tab-wrp > .beae-tab-contents > .beae-tab-content
       .beae-accordion-title--mobile  (clickable header)
       .beae-accordion-body           (collapsible content)
       .beae-accordion-icon--mobile[data-status="open"|"close"] (minus / plus icons) */
  function initBeaeAccordions() {
    var wraps = document.querySelectorAll('.beae-tab-wrp');
    Array.prototype.forEach.call(wraps, function (wrp) {
      var items = wrp.querySelectorAll('.beae-tab-content');
      if (items.length < 2) return;

      Array.prototype.forEach.call(items, function (item, idx) {
        var title = item.querySelector('.beae-accordion-title--mobile');
        var body = item.querySelector('.beae-accordion-body');
        if (!title || !body || title.dataset.tmBound) return;
        title.dataset.tmBound = '1';
        title.style.cursor = 'pointer';
        title.setAttribute('role', 'button');
        title.setAttribute('tabindex', '0');

        var iconOpen = item.querySelector('.beae-accordion-icon--mobile[data-status="open"]');
        var iconClose = item.querySelector('.beae-accordion-icon--mobile[data-status="close"]');

        function setOpen(open) {
          body.style.overflow = 'hidden';
          body.style.display = open ? '' : 'none';
          if (iconOpen) iconOpen.style.display = open ? '' : 'none';
          if (iconClose) iconClose.style.display = open ? 'none' : '';
          item.setAttribute('data-tm-open', open ? '1' : '0');
          title.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        // Start with the first item open, the rest collapsed (standard accordion).
        setOpen(idx === 0);

        function toggle() { setOpen(item.getAttribute('data-tm-open') !== '1'); }
        title.addEventListener('click', toggle);
        title.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            toggle();
          }
        });
      });
    });
  }

  function init() {
    try { initBeaeAccordions(); } catch (e) { /* no-op */ }
  }

  /* Re-create the BEAE scrolling-text (marquee) animation. After the app was
     uninstalled, BEAE's JS no longer duplicates the content nor applies the
     right-scroll animation, so the banners were frozen. We reproduce the exact
     original behaviour: duplicate .beae-marquee-content to 3 copies and animate
     the container with marqueeRIGHT-CENTER at BEAE's speed (width * 0.015s). */
  function initBeaeMarquees() {
    var containers = document.querySelectorAll('.beae-marquee-container');
    Array.prototype.forEach.call(containers, function (container) {
      if (container.dataset.tmMarquee) return;
      var content = container.querySelector('.beae-marquee-content');
      if (!content) return;
      var probe = content.getBoundingClientRect().width;
      if (probe < 20) return; // not laid out yet — try again later

      // BEAE's CSS applies "animation: marqueeRIGHT-CENTER" by default but its JS
      // (now gone) never set --marquee-animation-offset, so nothing moves. Only skip
      // if that offset is already set to a real value (i.e. BEAE's JS actually ran).
      var existingOffset = window.getComputedStyle(container).getPropertyValue('--marquee-animation-offset').trim();
      if (existingOffset && existingOffset !== '0px') { container.dataset.tmMarquee = '1'; return; }

      container.dataset.tmMarquee = '1';
      // Two extra copies -> 3 identical copies for a seamless loop.
      container.appendChild(content.cloneNode(true));
      container.appendChild(content.cloneNode(true));
      container.style.display = 'flex';
      container.style.flexWrap = 'nowrap';
      container.style.width = 'max-content';

      var wrap = container.closest('.beae-scroll-text-container') || container.parentElement;
      if (wrap) { wrap.style.overflow = 'hidden'; wrap.style.maxWidth = '100%'; }

      var oneWidth = content.offsetWidth || probe;
      var duration = Math.max(8, oneWidth * 0.015).toFixed(3);
      container.style.setProperty('--marquee-animation-offset', '-' + Math.round(oneWidth) + 'px');
      container.style.animation = duration + 's linear infinite marqueeRIGHT-CENTER';
      container.style.willChange = 'transform';
    });
  }

  function initMarquees() { try { initBeaeMarquees(); } catch (e) { /* no-op */ } }

  /* The reviews (.beae-slider-content in the beae-c4sulhzy section) should scroll as
     one smooth, continuous horizontal loop showing ~4 at a time — exactly like the
     text banners. BEAE's slider JS is gone (app uninstalled) so it sat frozen. We
     reuse the proven banner marquee: triple the cards and animate the track with
     marqueeRIGHT-CENTER. Desktop only — mobile keeps its stacked grid. Pauses on hover. */
  function initTmReviewsMarquee() {
    if (window.innerWidth <= 749) return; // mobile keeps the stacked grid
    var sec = document.querySelector('[data-sectionid="beae-c4sulhzy"]');
    if (!sec) return;
    var wrapper = sec.querySelector('.beae-slider-wrapper');
    var track = sec.querySelector('.beae-slider-content');
    if (!wrapper || !track || track.dataset.tmReviewsMarquee) return;
    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) return;
    if (track.getBoundingClientRect().width < 40) return; // not laid out yet — retry later

    var cardW = Math.round(cards[0].getBoundingClientRect().width) || 282;
    track.dataset.tmReviewsMarquee = '1';
    // Force a single non-wrapping row we can translate.
    track.style.display = 'flex';
    track.style.flexWrap = 'nowrap';
    track.style.alignItems = 'flex-start';
    track.style.width = 'max-content';
    track.style.gap = '20px';
    track.style.gridTemplateColumns = 'none';
    track.style.transform = 'none';

    // Triple the original cards for a seamless loop.
    cards.forEach(function (c) { track.appendChild(c.cloneNode(true)); });
    cards.forEach(function (c) { track.appendChild(c.cloneNode(true)); });

    // Pin every card to its original width so the text doesn't stretch the row.
    Array.prototype.forEach.call(track.children, function (c) {
      c.style.flex = '0 0 ' + cardW + 'px';
      c.style.width = cardW + 'px';
      c.style.maxWidth = cardW + 'px';
    });

    // Exact width of one copy = left of the first card of copy 2 minus copy 1.
    var kids = track.children;
    var oneWidth = kids[cards.length].offsetLeft - kids[0].offsetLeft;
    if (oneWidth < 40) oneWidth = Math.round(track.scrollWidth / 3);

    wrapper.style.overflow = 'hidden';
    wrapper.style.maxWidth = '100%';

    var duration = Math.max(30, Math.round(oneWidth * 0.02)); // slow + elegant, readable
    track.style.setProperty('--marquee-animation-offset', '-' + oneWidth + 'px');
    track.style.animation = duration + 's linear infinite marqueeRIGHT-CENTER';
    track.style.willChange = 'transform';

    // Keep the left/right arrows (users can step through), but hide the progress
    // bar and pagination dots for a clean look.
    ['.beae-slider-progress', '.beae-slider-pagination-wrp'].forEach(function (sel) {
      var el = sec.querySelector(sel);
      if (el) { el.style.display = 'none'; }
    });

    // Wire the arrows: step one card and pause the auto-scroll so a reader can stop
    // on a review. We drive the running CSS animation's own timeline (currentTime),
    // so a click moves the row synchronously — no dependency on BEAE's dead JS.
    var anim = (track.getAnimations && track.getAnimations()[0]) || null;
    var gapPx = 20;
    function stepCards(dir) { // dir: +1 = right/next (row slides left), -1 = left/prev
      if (!anim) return;
      track.style.animationPlayState = 'paused';
      var dur = anim.effect.getTiming().duration;
      var deltaT = (cardW + gapPx) / oneWidth * dur;
      var t = (typeof anim.currentTime === 'number') ? anim.currentTime : 0;
      anim.currentTime = ((t - dir * deltaT) % dur + dur) % dur;
    }
    var navL = sec.querySelector('.beae-slider-nav-left');
    var navR = sec.querySelector('.beae-slider-nav-right');
    if (navL) { navL.style.cursor = 'pointer'; navL.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); stepCards(-1); }); }
    if (navR) { navR.style.cursor = 'pointer'; navR.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); stepCards(1); }); }

    // Pause on hover so people can read a review; resume when the pointer leaves.
    wrapper.addEventListener('mouseenter', function () { track.style.animationPlayState = 'paused'; });
    wrapper.addEventListener('mouseleave', function () { track.style.animationPlayState = 'running'; });
  }

  function initReviews() { try { initTmReviewsMarquee(); } catch (e) { /* no-op */ } }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Marquee width depends on the display font, so set it up after fonts load. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { initMarquees(); initReviews(); });
  }
  window.addEventListener('load', function () { setTimeout(function () { initMarquees(); initReviews(); }, 200); });
  setTimeout(function () { initMarquees(); initReviews(); }, 1500);
  /* Homepage hero tagline: put each sentence on its own line. The BEAE text is one
     string with no spaces after the periods ("...recunosti.Fictiunea..."), so it wraps
     mid-sentence; insert a <br> after each sentence-ending period. Idempotent + safe. */
  function initHeroTagline() {
    var sec = document.querySelector('[data-sectionid="beae-bmsmlcu7"]');
    if (!sec) return;
    Array.prototype.forEach.call(sec.querySelectorAll('.beae-x-text'), function (el) {
      if (el.dataset.tmSplit === '1' || el.querySelector('br')) { el.dataset.tmSplit = '1'; return; }
      var t = (el.textContent || '').trim();
      if (!/recuno[șs]ti|Referin/i.test(t)) return;
      el.innerHTML = t.replace(/\.\s*(?=[A-ZĂÂÎȘȚ])/g, '.<br>');
      el.dataset.tmSplit = '1';
    });
  }
  function tmBootHero() { try { initHeroTagline(); } catch (e) {} }
  tmBootHero();
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(tmBootHero); }
  window.addEventListener('load', function () { setTimeout(tmBootHero, 300); });
  setTimeout(tmBootHero, 1600);
})();

